export default __webpack_public_path__ + "static/media/wanna6.c8bdd344.webp";